<template>
  <div
    class="orderCard-container"
    :class="{ open: insideOpen }"
    @click.self="closeHandler"
  >
    <div
      class="content d-flex justify-content-center align-items-center flex-column"
      :class="{ open: insideOpen }"
    >
      <h2>商品清單</h2>
      <ul>
        <li v-for="data in insideOrderCardData" :key="data.id">
          {{ data.product.title }} * {{ data.quantity }} 件 金額:
          {{ data.product.price * data.quantity }}
        </li>
      </ul>
      <p class="mt-3">原價: {{ total }}</p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    insideOpen: {
      type: Boolean,
      default: false,
    },
    insideOrderCardData: {
      default: [],
    },
  },
  methods: {
    closeHandler() {
      this.$emit('openCardHandler', false);
    },
  },
  computed: {
    total() {
      return this.insideOrderCardData.reduce((old, cur) => {
        return old + cur.product.price * cur.quantity;
      }, 0);
    },
  },
};
</script>

<style lang="scss" scoped>
.orderCard-container {
  display: none;
}
.orderCard-container.open {
  display: block;
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.267);
}
.content.open {
  position: absolute;
  left: 50%;
  top: 30%;
  width: 360px;
  padding: 25px;
  transform: translate(-50%, -50%);
  background-color: #fff;
  ul,
  h2 {
    width: 100%;
    text-align: center;
  }
  h2 {
    font-size: 28px;
    padding-bottom: 10px;
  }
  li {
    padding: 10px;
  }
  li,
  h2 {
    border-bottom: 1px dotted #000;
  }
}
</style>
